import { Procedure } from "../../../types/procedures";
import { procedurePinRank } from "../components/QuoteProceduresList/specialBadge";
import { useQuote } from "../QuoteProvider";

type GetProceduresByTypeParams = {
  procedureType: string;
};

export function useGetProceduresByType({
  procedureType,
}: GetProceduresByTypeParams) {
  const quoteData = useQuote();

  const source: Procedure[] =
    procedureType === "all"
      ? quoteData.procedures
      : quoteData.procedures.filter((procedure: Procedure) =>
          (procedure.procedureTypes || []).some((pt) => pt.id === procedureType),
        );

  // Specials pinned first, then featured, everything else keeps catalog
  // (position) order — mirrors the iOS Explore carousel.
  // (Out-of-window procedures are already filtered out upstream in QuoteProvider.)
  return [...source].sort((a: any, b: any) => {
    const aRank = procedurePinRank(a);
    const bRank = procedurePinRank(b);
    if (aRank !== bRank) return aRank - bRank;
    return (a.position ?? Infinity) - (b.position ?? Infinity);
  });
}
